import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { FormattedMessage } from 'react-intl'

import { MENU_CONFIGURATION, LOCALE_PREFIX } from './constants'

import Menu from './components/Menu'
import Content from './components/Content'

import hocConnect from './hocConnect'
import HocDialogComponent from '../../../../services/dialog/hocDialogComponent'

import './style.scss'

@hocConnect
@HocDialogComponent
export default class UserProfile extends Component {
    static propTypes = {
        activePath: PropTypes.array.isRequired,
        closeDialog: PropTypes.func.isRequired,
        type: PropTypes.string.isRequired,
    }

    onButtonClick = (buttonType) => {
        if (buttonType === 'close') {
            const { type, closeDialog } = this.props

            closeDialog(type)
        }
    }

    defineHeader = () => ({
        text: <FormattedMessage id={`${LOCALE_PREFIX}.title`} />,
        icon: '',
    })

    defineFooter = () => [
        {
            type: 'close',
            text: <FormattedMessage id={`${LOCALE_PREFIX}.button.close`} />,
        },
    ]

    render() {
        const { activePath } = this.props

        return (
            <div className={'user-profile'}>
                <Menu configuration={MENU_CONFIGURATION} />
                <Content contentPath={activePath} />
            </div>
        )
    }
}
